<template>
    <div>
        <vsmallheader></vsmallheader>
        <div class="metter">
                
                <div style="font-size:16px;padding-bottom:20px;display: flex;">
                  <div style="font-size:14px;color:#888;display:flex;align-items: center">
                    <img src="@/assets/resource/adresst.png" style="width:15px;height:15px;margin-right:5px" />
                    当前位置：
                  </div>
                  <span style="cursor: pointer;font-size: 14px;" @click="retrun">调训管理 </span>/基地列表 
                  </div>
                <div class="mettera">
                    <div>
                        <div class="cate">
                            <!-- <div class="cate_police">
                                <div class="cate-all">状态：</div>
                                <div class="subject">
                                    <span
                                        v-for="(item, index) in stasedata"
                                        :key="index"
                                        :class="{heightlight : staseIndex==index}"
                                        @click="staseArea(index,item)"
                                    >
                                        {{ item.name }}
                                    </span>
                                </div>
                            </div> -->

                            <div class="cate_police">
                                <div class="cate-all">基地级别：</div>
                                <div class="subject">
                                    <span
                                        v-for="(item, index) in baseTypedata"
                                        :key="index"
                                        :class="{heightlight : baseTypeIndex==index}"
                                        @click="baseTypeArea(index,item)"
                                    >
                                        {{ item.name }}
                                    </span>
                                </div>
                            </div>

                            <div class="cate_police">
                                <div class="cate-all">地市/州 ：</div>
                                <div class="subject">
                                    <span
                                    v-for="(item, index) in cityList"
                                    :key="index"
                                    :class="{heightlight : cityIndex==index}"
                                    @click="selectCity(index,item)"
                                    >{{ item.name }}</span>
                                </div>
                            </div>
              <div
                class="cate_police"
                style="border-top: 1px solid #dcdfe6;margin-right: 32px;margin-left: 160px;padding-top: 10px; "
              >
                <!-- <div class="subject" style="padding-right: 30px;">
                  <span
                    v-for="(item, index) in assitList"
                    :key="index"
                    :class="{heightlight : assitIndex==index}"
                    @click="policeassit(index,item)"
                  >{{item.name}}</span>
                </div> -->
                <el-input
                  @keyup.enter.native="getnewsList"
                  size="large"
                  placeholder="请输入搜索内容"
                  v-model="listQuery.name"
                  class="input-with-select"
                  style="width:300px; color: white;height: 40px;border-top-left-radius: 5px;border-bottom-left-radius: 5px;"
                >
                  <el-button
                    @click="getbaseList"
                    slot="append"
                    icon="el-icon-search"
                    style="background: #545c63;border-top-left-radius: 0px;border-bottom-left-radius: 0px;height: 40px;color: white; font-size: 16px;"
                  ></el-button>
                </el-input>
              </div>
            </div>
          </div>
            <!-- <div class="header">
                训练基地
            </div> -->
            <div class="imageList">
                    <div  class="zoumadeng">
                        <div v-for="(items,indexs) in baseData" :key="indexs" style="margin-top:10px">
                                <img :src="items.imgface" alt="" style="width:270px;height:185px;cursor: pointer; margin-left:10px;" @click="trainBase(items.id)">
                                <div style="text-align: center;font-size:16px">{{items.basename}}</div>
                        </div>
                    </div>
            </div>
          
          <div class="pageblock">
            <el-pagination
              background
              prev-text="上一页"
              next-text="下一页"
              layout="total,prev, pager, next,jumper"
              :page-size="listQuery.limit"
              :current-page.sync="listQuery.page"
              :total="dataCount"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import { getCity } from '@/api/public.js';
import vsmallheader from '@/views/smallHeader/index';
import linecom from '@/components/linecom/index';
import * as trainapi from '@/api/train/index';
import * as teacherInfo from '@/api/teacher/teacherInfo';
export default {
    components: {
        vsmallheader,linecom
    },
    data(){
        return{
            dataCount:0,
            //71
            baseTypedata:[{name:'全部',id:0}],
            stasedata:[{name:'全部',id:0},{name:'使用中',id:1},{name:'闲置中',id:2}],
            cityList: [{ name: '全部', id: 0 }],
            assitList:[{name:'全部',id:0},{name:'最新',id:1},{name:'最热',id:2}],
            staseIndex:0,
            baseTypeIndex:0,
            assitIndex:0,
            cityIndex:0,
            baseData:[],
            listQuery: {
                page: 1,
                limit: 8,
                deptId: null,
                baseType: null,
                name: '',
            },
            listQuery2:{
              namespaceId:71
            },

        }
    },
    created(){
        this.getPmiDictionary(71, this.baseTypedata); //获取警种数组
        this.getDishi()
        this.getbaseList()
    },
    methods:{
      getPmiDictionary(index, arr) {
        this.listQuery2.namespaceId = index;
        teacherInfo
          .getPmiDic(this.listQuery2)
          .then((response) => {
            response.result.forEach((e) => {
              arr.push({ name: e.name, id: e.id });
            });
          })
          .catch(() => {});
      },
        trainBase(Id) {
            this.$router.push({
                path: '/train/trainBase',
                query: {
                    id: Id,
                },
            });
        },
        //获取地市
        getDishi() {
            getCity().then((res) => {
                res.result.forEach((e) => {
                    this.cityList.push({ name: e.name, id: e.id });
                });
            });
        },
        retrun() {
            this.$router.go(-1);
        },
        getbaseList(){

        },
        policeassit(index,item){
            this.assitIndex=index
        },
        selectCity(index,item){
            this.cityIndex=index
        },
        staseArea(index,item){
            this.staseIndex=index
        },
        baseTypeArea(index,item){
            this.listQuery.baseType=item.id
            this.baseTypeIndex=index
            this.getbaseList()
        },
        getbaseList() {
            trainapi.GetLoadTrainBase(this.listQuery).then((res) => {
                this.baseData = res.data;
                this.dataCount=res.count
            });
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getbaseList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getbaseList();
        },
    },
}
</script>
<style scoped>
/* 高亮 */
.heightlight {
  background-color: #3c95d6 !important;
  /* border: 1px solid #4876C4; */
  color: #f8fafc !important;
}
.metter {
  width: 1200px;
  min-height: 750px;
  /* background-color:; */
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.mettera {
  padding-top: 20px;
  width: 1200px;
  min-height: 750px;

  /* height: 700px; */
  /* background-color:; */
  margin: 0 auto;
  box-shadow: 2px 2px 5px rgba(215, 215, 215, 0.968627450980392);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(242, 242, 242, 1);
  border-radius: 5px;
}

li {
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  margin-left: 20px;
  list-style-type: disc;
  display: flex;
  justify-content: space-between;
  margin-right: 30px;
  font-size: 16px;
  margin-top: 8px;
}
li > div:nth-child(1) {
  display: flex;
}
li > div:nth-child(1) > div:nth-child(1) {
  border-radius: 50%;
  height: 10px;
  width: 10px;
  background-color: #333;
  margin-top: 9px;
  margin-right: 20px;
}
li > div:nth-child(1) > div:nth-child(2) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
li:hover {
  color: rgb(87, 179, 255);
}
li:hover > div:nth-child(1) > div:nth-child(1) {
  border-radius: 50%;
  height: 10px;
  width: 10px;
  background-color: rgb(87, 179, 255);
}
.pageblock {
  padding-bottom: 20px;
  margin-top: 20px;
  text-align: center;
}

.cate {
  width: 1180px;
  /* height: 72px; */
  /* background: #ffffff; */
  margin: 0 auto;
  /* margin-top: 20px; */
  padding: 0px 10px;
  /* box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16); */
  /* box-shadow: 0 4px 8px 0 rgb(95 101 105 / 5%); */
}
.cate_police {
  display: flex;
  font-size: 16px;
  margin-left: 32px;
  /* font-family: Source Han Sans CN; */
  padding: 5px 0;
  /* height: 100px; */
}
.cate-all {
  width: 140px;
  font-weight: 700;
}
.subject {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.subject > span {
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #333333;
  margin-right: 10px;
  /* background: #ECECEC; */
  opacity: 1;
  border-radius: 6px;
  margin-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid white;
  border-radius: 5px;
}
.subject > span:hover {
  border: 1px solid #3c95d6;
  color: #3c95d6;
  border-radius: 5px;
}
.header {
  margin-top: 30px;
  margin-left: 25px;
  text-align: center;
  line-height: 90px;
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  width: 1150px;
  height: 110px;
  background-image: url('../../../assets/train/u756.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.imageList {
  padding: 10px;
  width: 1150px;
 margin-left: 25px;
  height: 450px;
  background-color: #fff;
}
.zoumadeng {
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}

</style>